<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('POINTAGES')">
        <slot name="section-pointages">
          <section-pointages ref="POINTAGES"
                             id="POINTAGES"
                             :extended="isExtended('POINTAGES')"
                             :showButton="true"
                             :autoSave="true"
                             :readOnly="readOnly"
                             :moduleId="moduleId"
                             :searchText="searchText"
                             :ressourceHeader="ressource"
                             :fiche="fiche"
                             :user=selectedUser
                             :route="route"
                             :attribut="attribut"
                             @extended="setExtended"
                             @fullscreen="setFullscreen"
                             @status="updateStatus"
                             @updated="userUpdated"
                             @selectItem = "selectItem">
          </section-pointages>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import User from '@/extend/classes/User';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionPointages from '@/custom/sections/SectionPointages.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionPointages,
    FicheHeader,
  },

  props: {
    user: {
      type: Object as PropType<User>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.POINTAGES,
      sections: [
        'POINTAGES',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_POINTAGES);
    },

    selectedUser (): User {
      return this.user
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    userUpdated (user: User) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.user || this.user.id < 0) && value == 'POINTAGES') {
        this.setExtended(new Extended('POINTAGES', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
